<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">ELI Sections</h1>
                </div>

                <!--<div class="card shadow">-->

                <div class="topSpacing">
                    <div class="desktopTabs">
                        <ul class="tab-nav">
                            <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#tab1">Regular</a></li>
                            <li (click)="tabSelect(1)"><a data-toggle="tab" href="#tab2">Satisfaction</a></li>
                            <li (click)="tabSelect(2)"><a data-toggle="tab" href="#tab3">Survey</a></li>
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div id="tab1" class="tab-pane fade in active">
                            <app-regular></app-regular>
                        </div>

                        <div id="tab2" class="tab-pane fade">
                            <app-satisfaction></app-satisfaction>
                        </div>

                        <div id="tab3" class="tab-pane fade">
                            <app-survey></app-survey>
                        </div>
                    </div>
                </div>

                <!--</div>-->
            </div>
        </div>
    </div>
</div>